exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-right[data-v-7baf75b5]{width:100%;display:flex;flex-direction:row-reverse;margin-bottom:0.05208rem}.wrap-right .wrap-right-btn[data-v-7baf75b5]{box-sizing:inherit}\n", ""]);

// exports
